import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem5,
    GridItem6,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

import { 
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    processaRegistrosDefaultIniciaisExclusaoFamiliares,
    obtemExclusaoFamiliaresList,
} from './EstudoServiceExclusaoFamiliares'

const EstudoFormExclusaoFamiliares = ({ values, handleChange }) => {

    processaRegistrosDefaultIniciaisExclusaoFamiliares(values)
    console.log(values.exclusaoFamiliares)

    return (
        <CardGridEntradaDados>
            <CardGridDivHeaderEntradaDados>
                <CardGridDivEntradaDados>
                    {LABEL.exclusaoFamiliares}
                </CardGridDivEntradaDados>
            </CardGridDivHeaderEntradaDados>

            <CardGridDivBody>
                <FieldArray name="exclusaoFamiliares">
                    {(arrayHelpers) => (
                        <DivForm>
                            <DivForm
                                style={{
                                    display: values.exclusaoFamiliares && values.exclusaoFamiliares.length > 0 ? "block" : "none"
                                }}
                            >
                                {values.exclusaoFamiliares?.map((item, ind) => {
                                    return (
                                        <GridContainer
                                            key={ind}
                                        >
                                            <GridItem12>
                                                <GridContainer>
                                                    <GridItem6>
                                                        <TextFieldNumberSelect
                                                            name={`exclusaoFamiliares[${ind}].id`}
                                                            label={LABEL.familiarASerExcluido}
                                                            value={item.id || ''}
                                                            onChange={handleChange}
                                                            list={obtemExclusaoFamiliaresList(values, item.id)}
                                                        />
                                                    </GridItem6>

                                                    <GridItem5 />

                                                    <GridItem1>
                                                        <IconButtonClearEntradaDados
                                                            onClick={() =>
                                                                arrayHelpers.remove(ind)
                                                            }
                                                        />
                                                    </GridItem1>
                                                </GridContainer>
                                            </GridItem12>
                                        </GridContainer>
                                    )
                                })}
                            </DivForm>

                            <GridContainer>
                                <ButtonIncluirLinha
                                    label={LABEL.buttonIncluirExclusaoFamiliar} 
                                    onClick={() => 
                                        arrayHelpers.push({
                                        })
                                    }
                                />
                            </GridContainer>
                        </DivForm>
                    )}
                </FieldArray>
            </CardGridDivBody>
        </CardGridEntradaDados>
    )
}

export default EstudoFormExclusaoFamiliares